import React, { useEffect, useState } from 'react';
import { Editor } from './components/Editor';
import { Preview } from './components/Preview';
import { ExportModal } from './components/ExportModal';
import { LanguageSelector } from './components/LanguageSelector';
import { DownloadIcon, MoonIcon, SunIcon } from 'lucide-react';
import { useLanguage } from './i18n/useLanguage';
const DEFAULT_MARKDOWN = `# Welcome to InfoGiraffe, Generating beautiful InfoGraphic

## Features
- ✨ Real-time Markdown preview
- 🎨 Beautiful image export
- 💾 Auto-save

## Code Example

\`\`\`javascript
function hello() {
  console.log("Hello, World!");
}
\`\`\`

Start writing your notes!`;
export function App() {
  const [markdown, setMarkdown] = useState(DEFAULT_MARKDOWN);
  const [showExport, setShowExport] = useState(false);
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved === 'dark';
  });
  useEffect(() => {
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);
  const toggleTheme = () => {
    setIsDark(!isDark);
  };
  return <div className={`w-full min-h-screen flex flex-col ${isDark ? 'bg-[#1a1d23]' : 'bg-[#f7f7f5]'}`} data-id="element-0">
      {/* Header */}
      <header className={`px-8 py-6 flex items-center justify-between shadow-sm ${isDark ? 'bg-[#242830]' : 'bg-white'}`} data-id="element-1">
        <div className="flex items-center gap-4" data-id="element-2">
          <div className="relative w-12 h-12 rounded-2xl overflow-hidden flex-shrink-0 shadow-sm" data-id="element-3">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ksjhreXsrwevnA5a2NvFJV/unnamed.jpg" alt="InfoGiraffe Logo" className="w-full h-full object-cover" data-id="element-4" />
          </div>
          <h1 className={`text-2xl font-light tracking-wide ${isDark ? 'text-[#f5f7f9]' : 'text-[#2c3e50]'}`} data-id="element-5">
            InfoGiraffe
          </h1>
        </div>
        <div className="flex items-center gap-3" data-id="element-6">
          <LanguageSelector language={language} onLanguageChange={setLanguage} isDark={isDark} data-id="element-7" />
          <button onClick={toggleTheme} className={`p-3 rounded-full transition-all duration-200 ${isDark ? 'bg-[#2d3340] hover:bg-[#353b4a] text-[#7b92a8]' : 'bg-[#f5f5f5] hover:bg-[#e8ecf0] text-[#5b7c8d]'}`} aria-label={t('app.toggleTheme')} title={t('app.toggleTheme')} data-id="element-8">
            {isDark ? <SunIcon className="w-5 h-5" data-id="element-9" /> : <MoonIcon className="w-5 h-5" data-id="element-10" />}
          </button>
          <button onClick={() => setShowExport(true)} className={`flex items-center gap-2 px-6 py-3 rounded-full transition-all duration-200 shadow-sm hover:shadow-md font-light ${isDark ? 'bg-[#7b92a8] text-white hover:bg-[#6a8199]' : 'bg-[#5b7c8d] text-white hover:bg-[#4a6b7c]'}`} data-id="element-11">
            <DownloadIcon className="w-4 h-4" data-id="element-12" />
            {t('app.exportImage')}
          </button>
        </div>
      </header>
      {/* Main Content */}
      <div className="flex-1 flex overflow-hidden gap-6 p-6" data-id="element-13">
        <Editor markdown={markdown} onChange={setMarkdown} isDark={isDark} t={t} data-id="element-14" />
        <Preview markdown={markdown} isDark={isDark} t={t} data-id="element-15" />
      </div>
      {/* Export Modal */}
      {showExport && <ExportModal markdown={markdown} onClose={() => setShowExport(false)} isDark={isDark} t={t} data-id="element-16" />}
    </div>;
}